import { atom } from "jotai";

export const companyCodeAtom = atom<string>("");
